module.exports = __webpack_public_path__ + "static/media/low-version.ecde8f9f.png";